import api from "./client";

export const listGatewayProvisioningOverview = async () => {
  const { data } = await api.get("/gateway-export/sites/overview");
  return data;
};

export const getGatewayProvisioningPreflight = async (siteId) => {
  const { data } = await api.get(`/gateway-export/site/${siteId}/preflight`);
  return data;
};

export const listGatewayProvisioningHistory = async (siteId, params = {}) => {
  const { data } = await api.get(`/gateway-export/site/${siteId}/history`, {
    params: {
      limit: params.limit ?? 50,
      offset: params.offset ?? 0,
    },
  });
  return data;
};

const extractFilename = (headers, fallback) => {
  const disposition = headers?.["content-disposition"] || "";
  const match = disposition.match(/filename="?([^";]+)"?/i);
  if (match?.[1]) {
    return match[1];
  }
  return fallback;
};

const downloadBlobResponse = (response, fallbackFilename) => {
  const blob = new Blob([response.data], { type: response.headers["content-type"] || "application/octet-stream" });
  const url = window.URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = extractFilename(response.headers, fallbackFilename);
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  window.URL.revokeObjectURL(url);
};

export const downloadGatewayConfigBundle = async (siteId, payload = {}) => {
  const response = await api.post(`/gateway-export/site/${siteId}/config-bundle`, payload, {
    responseType: "blob",
  });
  downloadBlobResponse(response, `pvapp-gateway-config-site-${siteId}.json`);
  return response;
};

export const downloadGatewayCertBundle = async (siteId, payload = {}) => {
  const response = await api.post(`/gateway-export/site/${siteId}/mtls-bundle`, payload, {
    responseType: "blob",
  });
  downloadBlobResponse(response, `pvapp-gateway-mtls-site-${siteId}.zip`);
  return response;
};
